.stripe {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  height: var(--stripe-height);
  padding: 0 14px;
  font-size: var(--font-size-md);
  color: var(--stripe-zone-fg);
  background: var(--stripe-zone-bg);
  border-bottom: 1px solid var(--border);
}

.lead {
  flex: none;
  font-weight: var(--font-weight-semibold);
}

/* Хвост с цифрами уступает первым: если места мало, обрезается он, а не главная мысль
   «филиал в другом поясе». Сама мысль не обрезается никогда. */
.tail {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/*
 * На телефоне полоса перестаёт быть строкой: обрезать «у вас сейчас 14:40» многоточием
 * значит оставить мастеру ровно ту цифру, из-за которой он приедет не в то время.
 */
@media (width <= 767px) {
  .stripe {
    display: block;
    height: auto;
    padding: 7px 14px;
    font-size: var(--font-size-sm);
    line-height: 1.35;
  }

  .tail {
    white-space: normal;
  }
}
